import { classnames } from 'tailwindcss-classnames';
import { TransplantsContentBlockProps } from './_types';
import SummarySection from './_summarySection';
import TransplantsTable from './_transplantsTable';

const TransplantsContentBlock = ({
  startYear,
  endYear,
  transplantTotals,
  adultFlag = false,
}: TransplantsContentBlockProps): React.JSX.Element => {
  const summarySection = (
    <SummarySection
      startYear={startYear}
      endYear={endYear}
      transplantTotal={transplantTotals.grandTotal}
      adultFlag={adultFlag}
    />
  );
  const transplantsTable = <TransplantsTable {...transplantTotals} />;

  const containerCss = classnames(
    'max-w-5xl',
    'pb-5',
    'pt-0',
    'sm:pb-16',
    'md:grid',
    'grid-cols-7',
    'md:gap-5',
    'lg:gap-7'
  );
  const summaryCss = classnames('col-span-2');
  const transplantTableCss = classnames('col-span-5', 'mt-8', 'sm:mt-0');

  return (
    <div className={containerCss}>
      <div className={summaryCss}>{summarySection}</div>
      <div className={transplantTableCss}>{transplantsTable}</div>
    </div>
  );
};

export default TransplantsContentBlock;
